import {TIN_EXAMPLES_BY_COUNTRY} from './taxIdentificationNumbers.examples';

const AUSTRIA_TIN_REGEX = /^\d{2}-?\d{3}\/?\d{4}$/;
const BELGIUM_TIN_REGEX = /^\d{11}$/;
const BULGARIA_TIN_REGEX = /^\d{10}$/;
const CANADA_TIN_REGEX = /^\d{3}-?\d{3}-?\d{3}$/;
const CYPRUS_TIN_REGEX = /^\d{8}[A-Z]$/;
const CZECH_TIN_REGEX = /^\d{6}\/?\d{3,4}$/;
const GERMANY_TIN_REGEX = /^\d{11}$/;
const DENMARK_TIN_REGEX = /^\d{6}-?\d{4}$/;
const ESTONIA_TIN_REGEX = /^\d{11}$/;
const GREECE_TIN_REGEX = /^\d{9}$/;
const FINLAND_TIN_REGEX = /^\d{6}[-+A]\d{3}[0-9A-Z]$/;
const FRANCE_TIN_REGEX = /^[0123]\d{12}$/;
const GREAT_BRITAIN_TIN_REGEX = /^[A-Z]{2}\d{6}[ABCD]$/;
const CROATIA_TIN_REGEX = /^\d{11}$/;
const HUNGARY_TIN_REGEX = /(^\d{10}$)|(^\d{8}-[12]-\d{2}$)/;
const IRELAND_TIN_REGEX = /^\d{7}[A-Z]{1,2}$/;
const ITALY_TIN_REGEX = /(^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$)|(^\d{11}$)/;
const LITHUANIA_TIN_REGEX = /^\d{11}$/;
const LUXEMBOURG_TIN_REGEX = /^\d{13}$/;
const LATVIA_TIN_REGEX = /^\d{6}\d{5}$/;
const MALTA_TIN_REGEX = /(^(11|22|33|44|55|66|77|88)[0-9]{7}$)|(^[0-9]{7}[MGAPLHBZ]$)/;
const NETHERLANDS_TIN_REGEX = /^\d{9}$/;
const POLAND_TIN_REGEX = /(^\d{10}$)|(^\d{11}$)/;
const PORTUGAL_TIN_REGEX = /^\d{9}$/;
const ROMANIA_TIN_REGEX = /(^[0-9]{13}$)|(^(RO)?[0-9]{2,10}$)/;
const SPAIN_TIN_REGEX = /^[0-9KLMXYZ]\d{7}[A-Z]$/;
const SWEDEN_TIN_REGEX = /^\d{6}-?\d{4}$/;
const SLOVENIA_TIN_REGEX = /^\d{8}$/;
const SLOVAKIA_TIN_REGEX = /^\d{6}\/?\d{3,4}$/;

/**
 * Pure validation function returning a boolean
 *
 * Check if a TIN is valid for the country provided
 *
 * @param countryCode the country you want to check
 * */
export function checkTINByCountry(value: string, countryCode?: string): boolean {
    switch (countryCode) {
        case 'FR':
        case 'GP':
        case 'MQ':
        case 'GF':
        case 'RE':
        case 'YT':
        case 'PM':
        case 'BL':
        case 'MF':
        case 'WF':
        case 'TF':
            return FRANCE_TIN_REGEX.test(value);
        case 'AT':
            return AUSTRIA_TIN_REGEX.test(value);
        case 'BE':
            return BELGIUM_TIN_REGEX.test(value);
        case 'BG':
            return BULGARIA_TIN_REGEX.test(value);
        case 'CA':
            return CANADA_TIN_REGEX.test(value);
        case 'CY':
            return CYPRUS_TIN_REGEX.test(value);
        case 'CZ':
            return CZECH_TIN_REGEX.test(value);
        case 'DE':
            return GERMANY_TIN_REGEX.test(value);
        case 'DK':
            return DENMARK_TIN_REGEX.test(value);
        case 'EE':
            return ESTONIA_TIN_REGEX.test(value);
        case 'ES':
            return SPAIN_TIN_REGEX.test(value);
        case 'FI':
            return FINLAND_TIN_REGEX.test(value);
        case 'GB':
            return GREAT_BRITAIN_TIN_REGEX.test(value);
        case 'GR':
            return GREECE_TIN_REGEX.test(value);
        case 'HU':
            return HUNGARY_TIN_REGEX.test(value);
        case 'HR':
            return CROATIA_TIN_REGEX.test(value);
        case 'IE':
            return IRELAND_TIN_REGEX.test(value);
        case 'IT':
            return ITALY_TIN_REGEX.test(value);
        case 'LT':
            return LITHUANIA_TIN_REGEX.test(value);
        case 'LU':
            return LUXEMBOURG_TIN_REGEX.test(value);
        case 'LV':
            return LATVIA_TIN_REGEX.test(value);
        case 'MT':
            return MALTA_TIN_REGEX.test(value);
        case 'NL':
            return NETHERLANDS_TIN_REGEX.test(value);
        case 'PL':
            return POLAND_TIN_REGEX.test(value);
        case 'PT':
            return PORTUGAL_TIN_REGEX.test(value);
        case 'RO':
            return ROMANIA_TIN_REGEX.test(value);
        case 'SE':
            return SWEDEN_TIN_REGEX.test(value);
        case 'SI':
            return SLOVENIA_TIN_REGEX.test(value);
        case 'SK':
            return SLOVAKIA_TIN_REGEX.test(value);
        default:
            return true;
    }
}

export function getTINExampleByCountryAndLegalPersonType(countryCode?: string, legalPersonType?: string): string | null {
    if (!countryCode) return null;
    const entry = TIN_EXAMPLES_BY_COUNTRY[countryCode];
    if (!entry) return null;
    const match = (legalPersonType && (entry[legalPersonType as keyof typeof entry] ?? entry.default)) || entry.default;
    return match?.example ?? null;
}

export function getTINTypeByCountryAndLegalPersonType(countryCode?: string, legalPersonType?: string): string | null {
    if (!countryCode) return null;
    const entry = TIN_EXAMPLES_BY_COUNTRY[countryCode];
    if (!entry) return null;
    const match = (legalPersonType && (entry[legalPersonType as keyof typeof entry] ?? entry.default)) || entry.default;
    return match?.type ?? null;
}
